import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['featured', 'specialDetails', 'genre', 'productButtons'];
  static values = { trainingGenreId: String };

  connect() {
    this.toggleSpecialDetails();
    this.toggleProductButtons();
  }

  toggleSpecialDetails() {
    if (!this.hasFeaturedTarget || !this.hasSpecialDetailsTarget) return;

    this.specialDetailsTarget.hidden = !this.featuredTarget.checked;
  }

  toggleProductButtons() {
    if (!this.hasGenreTarget || !this.hasProductButtonsTarget) return;

    this.productButtonsTarget.hidden =
      this.genreTarget.value !== this.trainingGenreIdValue;
  }
}
